import {
    PAYMENT_GATEWAY_SERVICES_START,
    PAYMENT_GATEWAY_SERVICES_SUCCESS,
    PAYMENT_GATEWAY_SERVICES_FAILURE,
    PAYMENT_GATEWAY_REQUEST_START,
    PAYMENT_GATEWAY_REQUEST_SUCCESS,
    PAYMENT_GATEWAY_REQUEST_FAILURE,
    PAYMENT_GATEWAY_VIEW_START,
    PAYMENT_GATEWAY_VIEW_SUCCESS,
    PAYMENT_GATEWAY_VIEW_FAILURE,
    PAYMENT_GATEWAY_GENERATE_START,
    PAYMENT_GATEWAY_GENERATE_SUCCESS,
    PAYMENT_GATEWAY_GENERATE_FAILURE,
} from "./ActionConstant";

export function paymentGatewayServicesStart(data) {
    return {
        type: PAYMENT_GATEWAY_SERVICES_START,
        data,
    };
}
export function paymentGatewayServicesSuccess(data) {
    return {
        type: PAYMENT_GATEWAY_SERVICES_SUCCESS,
        data,
    };
}
export function paymentGatewayServicesFailure(error) {
    return {
        type: PAYMENT_GATEWAY_SERVICES_FAILURE,
        error,
    };
}

export function paymentGatewayRequestStart(data) {
    return {
        type: PAYMENT_GATEWAY_REQUEST_START,
        data,
    };
}
export function paymentGatewayRequestSuccess(data) {
    return {
        type: PAYMENT_GATEWAY_REQUEST_SUCCESS,
        data,
    };
}
export function paymentGatewayRequestFailure(error) {
    return {
        type: PAYMENT_GATEWAY_REQUEST_FAILURE,
        error,
    };
}

export function paymentGatewayGenerateStart(data) {
    return {
        type: PAYMENT_GATEWAY_GENERATE_START,
        data,
    };
}
export function paymentGatewayGenerateSuccess(data) {
    return {
        type: PAYMENT_GATEWAY_GENERATE_SUCCESS,
        data,
    };
}
export function paymentGatewayGenerateFailure(error) {
    return {
        type: PAYMENT_GATEWAY_GENERATE_FAILURE,
        error,
    };
}

export function paymentGatewayViewStart(data) {
    return {
        type: PAYMENT_GATEWAY_VIEW_START,
        data,
    };
}
export function paymentGatewayViewSuccess(data) {
    return {
        type: PAYMENT_GATEWAY_VIEW_SUCCESS,
        data,
    };
}
export function paymentGatewayViewFailure(error) {
    return {
        type: PAYMENT_GATEWAY_VIEW_FAILURE,
        error,
    };
}